import React from 'react'
import {Box, Chip as ChipUI, Tooltip, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import CancelIcon from '@material-ui/icons/Cancel';
import Tr from 'translations/Translations';


function Chip({
	label,
	value,
	onDelete,
	className,
	labelClassName,
	onClick,
	tooltip,
	customDeleteIcon,
	disabled = false
}) {

	const getLabelBody = () => {
		return (
			<Typography
				variant='caption'
				className={labelClassName}
			>
				{label && (
					<>
						<Box component='span' fontWeight='fontWeightBold'>
							{label}:
							</Box>
						{' '}
					</>
				)}
				{value}
			</Typography>
		)
	}

	const getLabel = () => {
		if (!tooltip) {
			return getLabelBody();
		}
		return (
			<Tooltip
				title={tooltip}
				placement="top"
			>
				{getLabelBody()}
			</Tooltip>
		)
	}

	return (
		<ChipUI
			className={className}
			label={getLabel()}
			deleteIcon={!!customDeleteIcon ? customDeleteIcon :
				<Tooltip title={Tr('delete')} placement="top">
					<CancelIcon/>
				</Tooltip>
			}
			onDelete={!!customDeleteIcon && !onDelete ? (() => {}) : onDelete}
			onClick={onClick}
			disabled={disabled}
		/>
	)
}

Chip.propTypes = {
	classes: PropTypes.any,
}

Chip.defaultProps = {
}

export default Chip;